import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { API_URL } from "../../config";

export function MegaMenu({ menu }: { menu: any | null }) {
  if (!menu || !menu.showDropdown) return null;

  return (
    <>
      <div className="fixed inset-0 top-0 -z-10 bg-primary/[0.03] dark:bg-black/30 pointer-events-none" />
      <div className="absolute left-0 right-0 top-full bg-card border-t-2 border-primary/25 shadow-elevated animate-slide-down hidden lg:block">
        <div className="h-1 w-full bg-gradient-brand opacity-90" />
        <div className="container mx-auto px-8 py-10 grid grid-cols-12 gap-10 bg-gradient-to-b from-primary/[0.04] via-card to-card">
          
          {/* Column 1: Categories */}
          <div className="col-span-3 border-r border-primary/10 pr-8">
            <p className="text-[11px] uppercase tracking-widest text-primary mb-4 font-bold">Shop By Category</p>
            <ul className="space-y-1">
              {(menu.categories || []).map((item: any) => (
                <li key={item._id}>
                  <Link 
                    to={item.path}
                    className="text-sm font-medium text-foreground hover:text-primary hover:bg-primary/5 rounded-lg transition-colors flex items-center gap-2 group py-2 px-2 -mx-2 border-l-2 border-transparent hover:border-primary"
                  >
                    {item.label}
                    <ArrowRight className="h-3 w-3 text-primary opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 2: Brands */}
          <div className="col-span-5 border-r border-primary/10 pr-8">
            <p className="text-[11px] uppercase tracking-widest text-primary mb-4 font-bold">Top Brands</p>
            <div className="grid grid-cols-3 gap-3">
              {(menu.brands || []).map((item: any) => (
                <Link
                  key={item._id}
                  to={item.path}
                  className="aspect-[2/1] rounded-xl bg-primary/[0.06] dark:bg-primary/10 border border-primary/15 shadow-sm flex items-center justify-center text-sm font-display font-semibold text-foreground hover:text-primary hover:border-primary/50 hover:bg-primary/10 hover:shadow-md transition-all text-center px-2"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Column 3: Featured Offer */}
          <div className="col-span-4">
            {menu.offer && (
              <div className="space-y-4">
                <p className="text-[11px] uppercase tracking-widest text-primary mb-4 font-bold">Special Offer</p>
                <Link 
                  to={menu.offer.path || "#"}
                  className="group relative overflow-hidden rounded-2xl aspect-[4/3] flex flex-col justify-end p-6"
                >
                  {menu.offer.image ? (
                    <img 
                      src={`${API_URL}/${menu.offer.image.replace(/\\/g, '/')}`} 
                      alt={menu.offer.title}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                  ) : (
                    <div className="absolute inset-0 bg-gradient-brand-strong" />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                  <div className="relative">
                    <h4 className="text-xl font-display font-bold text-white leading-tight">{menu.offer.title}</h4>
                    <div className="mt-3 flex items-center gap-1.5 text-sm font-semibold text-white/90">
                      Shop Now <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
                    </div>
                  </div>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
